<template>
    <div class="rooms-overview">
        <h4 class="h4">Místnosti</h4>

        <div class="room-list" v-if="rooms.length > 0">
            <div :key="room.id" v-for="room in rooms" class="room">
                <div class="room__title">{{ room.title }}</div>
                <div class="room__designation" v-if="room.designation">{{ room.designation }}</div>
                <div class="room__area">{{ room.area }} ㎡</div>
                <div class="room__controls">
                    <custom-button @click="update(room)" iconic><span icon edit></span>Upravit</custom-button>
                    <custom-button @click="remove(room)" iconic><span icon remove></span>Odstranit</custom-button>
                </div>
            </div>
        </div>

        <div v-if="rooms.length === 0" class="text--maroon m--t-1">
            Pro toto patro zatím nebyly vytvořeny žádné místnosti
        </div>

        <custom-button @click="addRoom" primaryadd class="m--t-1"><span icon>&plus;</span>Přidat místnost
        </custom-button>
    </div>
</template>

<script>
import {defaultModalParameters} from 'domovio-core/src/system/modal/modal.params';
import UpdateRoomDialog from '@/modules/ProjectModule/modules/OptionModule/components/FloorPlan/Room/UpdateRoomDialog';
import CreateRoomDialog from '@/modules/ProjectModule/modules/OptionModule/components/FloorPlan/Room/CreateRoomDialog';
import CustomButton from 'domovio-core/src/components/Button/CustomButton';

export default {
    name:       'RoomList',
    components: {CustomButton},
    props:      {
        floorId: {
            type:     String,
            required: true,
        },
        rooms:   {
            type:     Array,
            required: true,
        }
    },
    methods:    {
        update(room) {
            this.$modal.show(UpdateRoomDialog, {
                room:    room,
                floorId: this.floorId
            }, defaultModalParameters());
        },
        remove(room) {
            const {id, title} = room;
            this.$modal.show('dialog', {
                text:    'Opravdu chcete místnost <strong>' + title + '</strong> odstranit?',
                buttons: [
                    {
                        title:   'Zrušit',
                        handler: () => this.$modal.hide('dialog')
                    }, {
                        title:   'Odstranit',
                        handler: () => {
                            this.$store.dispatch('projects/project/floorPlan/removeRoom', {id, floorId: this.floorId})
                                .catch((message) => this.$dmv.notifyError(message));
                            this.$modal.hide('dialog');
                        }
                    },
                ]
            })
        },
        addRoom() {
            this.$modal.show(CreateRoomDialog, {floorId: this.floorId}, defaultModalParameters());
        }
    }
}
</script>
